import { keyBy } from 'lib/helpers';

import { BRANDS } from './../../../contexts/CruiseSearchContext/constants';

const getCabinDictionary = (pricingPanelDictionary, brandCode) => {
	const brand = BRANDS.find((b) => b.code === brandCode);

	const brandAlpha3Code = brand.alpha3Code.toUpperCase();

	const categories = brand.categories;

	const cabinClassOptions = [];

	categories.forEach((c) => {
		var label = pricingPanelDictionary[`labelCabinClass_${c}_${brandAlpha3Code}`];

		cabinClassOptions.push({
			id: c,
			label: label || c,
		});
	});

	const cabinClassDictionary = keyBy(cabinClassOptions, 'id');
	return {
		cabinClassOptions,
		cabinClassDictionary,
	};
};
export default getCabinDictionary;
